import { Outlet } from "react-router-dom";
import { useSmoothScroll } from "@/hooks/useSmoothScroll";
import { Nav } from "@/components/site/Nav";
import { Footer } from "@/components/site/Footer";

export const SiteLayout = () => {
  useSmoothScroll();
  return (
    <div className="relative min-h-screen bg-[#0A0B0D] text-white">
      <a href="#main" className="skip-link" data-testid="skip-to-content-link">
        Skip to content
      </a>
      <Nav />
      <main id="main" tabIndex={-1} className="outline-none">
        <Outlet />
      </main>
      <Footer />
      <div className="grain" aria-hidden="true" />
    </div>
  );
};
